/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BannedCommunity
 */
export interface BannedCommunity {
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    imgUrl: string;
}

/**
 * Check if a given object implements the BannedCommunity interface.
 */
export function instanceOfBannedCommunity(value: object): value is BannedCommunity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('imgUrl' in value) || value['imgUrl'] === undefined) return false;
    return true;
}

export function BannedCommunityFromJSON(json: any): BannedCommunity {
    return BannedCommunityFromJSONTyped(json, false);
}

export function BannedCommunityFromJSONTyped(json: any, ignoreDiscriminator: boolean): BannedCommunity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imgUrl': json['imgUrl'],
    };
}

export function BannedCommunityToJSON(json: any): BannedCommunity {
    return BannedCommunityToJSONTyped(json, false);
}

export function BannedCommunityToJSONTyped(value?: BannedCommunity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'imgUrl': value['imgUrl'],
    };
}

